/**
 * DI-3-D (N8) — boots the intake's resume when the Field Data workspace
 * mounts (any `/field-data/*` route, not only the intake pages): the active
 * session is picked up, the runner restored in ONE tab of this browser, the
 * folder re-read where a browser phase is pending, and the tab guards wired
 * (`features/intake/runner/resume.ts`). The intake chunk is imported lazily,
 * so the shell bundle does not carry it (DI-2-1 AC-10); the boot runs once
 * per tab.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const FIELD_DATA_PREFIX = "/field-data";

export function IntakeResumeHost(): null {
  const { pathname } = useLocation();
  const inFieldData =
    pathname === FIELD_DATA_PREFIX ||
    pathname.startsWith(`${FIELD_DATA_PREFIX}/`);
  useEffect(() => {
    if (!inFieldData) return;
    void import("../../features/intake/index.js")
      .then((m) => m.bootIntakeResume())
      .catch(() => undefined);
  }, [inFieldData]);
  return null;
}
